/* eslint-disable react/prop-types */
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import { FormikPhoneField, FormikSingleSelect, FormikTextField } from '../../../../../components/FormikFields'
import useCountrySelectOptions from '../../../../../hooks/useCountrySelectOptions'
import { PW_MANAGER_SELECT_PROPS } from '../../../../../util/inputAttrs'
import { FORM_FIELDS } from '../constants'

function IdentityContact(props) {
  const intl = useIntl(props)
  const { countryOptions, countryFilter } = useCountrySelectOptions()
  const { isIntegrated = true, isEmailEditable = true, isGws = false } = props
  const showMicrosoftContactFields = isIntegrated && !isGws

  return (
    <Row className="mb-4">
      <Col sm="12">
        <h6 className="fw-bold mb-4" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
          <FormattedMessage id="ENGAGE.ONBOARD.ACCOUNT_DETAILS" />
        </h6>

        <FormikTextField
          id={FORM_FIELDS.FIRST_NAME}
          title="FORM.FIRST_NAME"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_FIRST_NAME' })}
          required
          inline
          disablePasswordManager
        />
        <FormikTextField
          id={FORM_FIELDS.LAST_NAME}
          title="FORM.LAST_NAME"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_LAST_NAME' })}
          required
          inline
          disablePasswordManager
        />
        <FormikTextField
          id={FORM_FIELDS.DISPLAY_NAME}
          title="FORM.DISPLAY_NAME"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_DISPLAY_NAME' })}
          inline
          disablePasswordManager
        />
        <FormikTextField
          id={FORM_FIELDS.EMAIL}
          title="FORM.EMAIL"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_EMAIL' })}
          required
          inline
          disabled={!isEmailEditable}
          disablePasswordManager
        />
        {!isEmailEditable && (
          <p className="text-muted mb-2 mt-0" style={{ fontSize: '0.85rem' }}>
            <FormattedMessage id="EDIT_EMPLOYEE.EMAIL_SYNCED_READ_ONLY" />
          </p>
        )}
        <FormikPhoneField
          id={FORM_FIELDS.PHONE}
          idFormatted={FORM_FIELDS.PHONE_FORMATTED}
          title="ADMINISTRATION.PHONE"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_PHONE' })}
          inline
        />
        {showMicrosoftContactFields && (
          <FormikPhoneField
            id={FORM_FIELDS.MOBILE_PHONE}
            idFormatted={`${FORM_FIELDS.MOBILE_PHONE}Formatted`}
            title="FORM.MOBILE_PHONE"
            placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_MOBILE_PHONE' })}
            inline
          />
        )}

        {showMicrosoftContactFields && (
          <>
            <hr className="mb-3" />

            <h6 className="fw-bold mb-4" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              <FormattedMessage id="FORM.CONTACT_INFORMATION" />
            </h6>

            <FormikTextField
              id={FORM_FIELDS.STREET_ADDRESS}
              title="FORM.STREET_ADDRESS"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_STREET_ADDRESS' })}
              inline
              disablePasswordManager
            />
            <FormikTextField
              id={FORM_FIELDS.CITY}
              title="FORM.CITY"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_CITY' })}
              inline
              disablePasswordManager
            />
            <FormikTextField
              id={FORM_FIELDS.STATE}
              title="FORM.STATE"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_STATE' })}
              inline
              disablePasswordManager
            />
            <FormikTextField
              id={FORM_FIELDS.POSTAL_CODE}
              title="FORM.POSTAL_CODE"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_POSTAL_CODE' })}
              inline
              disablePasswordManager
            />
            <FormikSingleSelect
              id={FORM_FIELDS.COUNTRY}
              title="FORM.COUNTRY_REGION"
              defaultLabel={intl.formatMessage({ id: 'PLACEHOLDER.SELECT_COUNTRY' })}
              options={countryOptions}
              filterOption={countryFilter}
              inline
              {...PW_MANAGER_SELECT_PROPS}
            />
            <FormikPhoneField
              id={FORM_FIELDS.FAX}
              title="FORM.FAX"
              placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_FAX' })}
              inline
            />
          </>
        )}
      </Col>
    </Row>
  )
}

export default IdentityContact
